import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-p-10 modal-request-access" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[15px]" }
const _hoisted_3 = { class: "tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none tw-capitalize" }
const _hoisted_4 = { class: "tw-flex tw-gap-2 tw-items-center tw-w-full text-input-disable" }
const _hoisted_5 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_6 = {
  key: 1,
  class: "tw-flex tw-gap-2 tw-items-center tw-w-full text-input-disable"
}
const _hoisted_7 = { class: "tw-flex tw-items-center tw-w-full text-input-disable" }
const _hoisted_8 = {
  key: 0,
  class: "tw-h-[14px] tw-w-[14px] tw-mr-[10px]",
  src: "/img/lock1_icon.svg",
  alt: "icon"
}
const _hoisted_9 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_10 = {
  key: 1,
  class: "tw-flex tw-gap-2 tw-items-center tw-w-full text-input-disable"
}
const _hoisted_11 = { class: "button-container tw-flex tw-justify-end tw-mt-[40px] tw-gap-[10px]" }

import { getComponentUiText } from "@/utils/utilities";
import {
  ref,
  onBeforeMount,
  Ref,
  computed,
  PropType,
  onMounted,
  nextTick,
} from "vue";

import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import BaseInput from "@/components/common/form/baseInput.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import {
  getOrgPermLevels,
  fetchOrgAccessType,
  getOrgRoles,
  orgAccessRequestProcess,
  orgAccessOfferProcess,
} from "@/services/org";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import store from "@/store";
import BaseForm from "../common/form/baseForm.vue";
import get from "lodash/get";
import { actionClickType } from "@/utils/constants";

import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Invite, Org } from "@/services/apiRoutes/routes";
import ButtonLoading from "../common/buttonLoading.vue";
const DEFAULT_MAX_WIDTH_MODAL = 65;


export default /*#__PURE__*/_defineComponent({
  __name: 'processRequestAccessDetailModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  action: {
    type: String,
    required: true,
    default: "",
  },
  requestDetail: {
    type: Object as PropType<any>,
    required: true,
  },
},
  emits: ["update:show", "update:data"],
  setup(__props, { emit }) {

const props = __props;

const orgRelationshipOptions: Ref<IDropDownData[]> = ref([]);

const permissionLevelOptions: Ref<IDropDownData[]> = ref([]);


const currentOrg = computed(() => store.state.Org.currentOrg);



const initialForm: any = {
  email: "",
  orgToOrgTypeId: null,
  isLocked: true,
  role: "",
};

const roleOfOffer = ref("");
const isCallApi = ref(false);

onMounted(() => {
  formModel.value.email = props.requestDetail?.requestedBy;
  formModel.value.orgToOrgTypeId = props.requestDetail?.orgRelationshipType;
  formModel.value.isLocked = props.requestDetail?.lockStatus;
  formModel.value.role = props.requestDetail?.role;
});

const onGetOrgRelationshipLabel = (id) => {
  const orgRelationship = orgRelationshipOptions.value.find(
    (relationship) => relationship.id === id,
  );
  return orgRelationship?.name;
};

const formModel: Ref<any> = ref({});

const rules =
  props.action === actionClickType.actionProcessRequest
    ? {
        orgToOrgTypeId: {
          required: helpers.withMessage(
            () => getComponentUiText("app-common-form-value-required-error-1"),
            required,
          ),
        },
        role: {
          required: helpers.withMessage(
            () => getComponentUiText("app-common-form-value-required-error-1"),
            required,
          ),
        },
      }
    : {};

const vueValidate = useVuelidate(rules, formModel);
let showRef = ref(props.show);

const clearData = () => {
  Object.assign(formModel, initialForm);
  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

const isCallAccept = ref(false);

const onSubmit = async (isApproved) => {
  isCallAccept.value = isApproved;
  await vueValidate.value.$validate();
  if (vueValidate.value.$invalid) return;
  if (props.action === actionClickType.actionProcessRequest) {
    onProcessRequest(isApproved);
  } else {
    onProcessOffer(isApproved);
  }
};

const onProcessRequest = async (isApproved) => {
  try {
    isCallApi.value = true;
    const body = {
      id: props.requestDetail.id,
      isApproved: isApproved,
      roleId: `${formModel.value.role}`,
      orgToOrgTypeId: formModel.value.orgToOrgTypeId,
    };
    const formResponse = await orgAccessRequestProcess(body);

    if (formResponse.data?.message) {
      showSuccessToast(
        getComponentUiText(
          !isApproved
            ? "app-settings-organisation-manage-access-process-request-reject-modal-1"
            : "app-settings-organisation-manage-access-process-request-approved-modal-1",
          false,
          { orgName: currentOrg.value?.nameShort },
        ),
      );
      emit("update:data");
      handleCloseModal();
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Invite.orgAccessRequestProcess);
    }
  } finally {
    isCallApi.value = false;
  }
};

const onProcessOffer = async (isApproved) => {
  try {
    isCallApi.value = true;
    const res = await orgAccessOfferProcess({
      id: props.requestDetail.id,
      isAccepted: isApproved,
    });
    if (res.data?.message) {
      emit("update:data");
      showSuccessToast(
        getComponentUiText(
          isApproved
            ? "app-settings-organisation-manage-access-process-offer-approve-modal-1"
            : "app-settings-organisation-manage-access-process-offer-reject-modal-1",
          false,
          { orgName: currentOrg.value?.nameShort },
        ),
      );
    }
    handleCloseModal();
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Invite.orgAccessOfferProcess);
    }
  } finally {
    isCallApi.value = false;
  }
};

const fetchRoleMembersTypesData = async () => {
  try {
    const permissionLevelResponse = await getOrgPermLevels();
    const permissionLevelResponseData = get(
      permissionLevelResponse,
      "data.data",
      [],
    );

    const roleResponse = await getOrgRoles();
    let roleResponseData = get(roleResponse, "data.data", []);

    const currentPemissionLevel = permissionLevelResponseData.find(
      (permission) =>
        permission.permissionLevelId === props.requestDetail.permLevelId,
    );

    // append role options based on permission level
    roleResponseData = roleResponseData
      .map((role) => {
        const permissionLevel = permissionLevelResponseData.find(
          (permission) =>
            permission.permissionLevelId === role.permissionLevelId,
        );
        if (permissionLevel) {
          return {
            ...role,
            permissionLevelValue: permissionLevel.permissionLevelValue,
          };
        }
      })
      .sort((a, b) => a.permissionLevelValue - b.permissionLevelValue);

    const roleOptions = roleResponseData.filter((role) => {
      return (
        role.permissionLevelValue >= currentPemissionLevel.permissionLevelValue
      );
    });

    permissionLevelOptions.value = roleOptions.map((relationship) => ({
      name: relationship.roleName,
      id: relationship.roleId,
    }));
    formModel.value.role = permissionLevelOptions.value[0]?.id;
    roleOfOffer.value = permissionLevelOptions.value[0]?.name;
  } catch (error: any) {
    permissionLevelOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgPermLevels);
    }
  }
};

const fetchOrgRelationship = async () => {
  try {
    const orgRelationshipResponse = await fetchOrgAccessType();
    if (orgRelationshipResponse?.data?.data) {
      orgRelationshipOptions.value = orgRelationshipResponse.data.data.map(
        (relationship) => ({
          name: relationship.name,
          id: relationship.id,
          isLockable: relationship.isLockable,
        }),
      );
    }
  } catch (error) {
    orgRelationshipOptions.value = [];
  }
};

const getFormData = async () => {
  fetchRoleMembersTypesData();
  fetchOrgRelationship();
};

onBeforeMount(() => {
  getFormData();
});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] request-access-detail-modal",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    visible: _unref(showRef),
    value: formModel.value,
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: "modal-header",
        title: 
        _unref(getComponentUiText)(
          __props.action === _unref(actionClickType).actionProcessRequest
            ? 'app-settings-organisation-manage-access-approved-request-modal-title-1'
            : 'app-settings-organisation-manage-access-approved-offer-modal-title-1',
        )
      ,
        "sub-title": currentOrg.value?.nameShort,
        onClose: handleCloseModal
      }, null, 8, ["title", "sub-title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              __props.action === _unref(actionClickType).actionProcessRequest
                ? "app-settings-organisation-manage-access-approved-request-modal-subtitle-1"
                : "app-settings-organisation-manage-access-approved-offer-modal-subtitle-1",
            )), 1)
        ]),
        _createVNode(BaseForm, {
          show: _unref(showRef),
          "enter-event": true
        }, {
          default: _withCtx(() => [
            _createVNode(BaseInput, {
              id: "name",
              modelValue: formModel.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.email) = $event)),
              disabled: "",
              label: 
            _unref(getComponentUiText)(
              __props.action === _unref(actionClickType).actionProcessRequest
                ? 'app-settings-organisation-manage-access-approved-request-modal-label-requested-by-1'
                : 'app-settings-organisation-manage-access-approved-request-modal-label-offer-by-1',
            )
          ,
              "label-tooltip": 
            _unref(getComponentUiText)(
              __props.action === _unref(actionClickType).actionProcessRequest
                ? 'app-settings-organisation-manage-access-approved-request-modal-hint-requested-by-1'
                : 'app-settings-organisation-manage-access-approved-request-modal-hint-offer-by-1',
            )
          
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(formModel.value.email), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "label-tooltip"]),
            _createVNode(BaseInput, {
              id: "org-relationship",
              modelValue: formModel.value.orgToOrgTypeId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.orgToOrgTypeId) = $event)),
              disabled: __props.action !== _unref(actionClickType).actionProcessRequest,
              validation: _unref(vueValidate).orgToOrgTypeId,
              label: 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-modals-label-org-relationship-1',
            )
          ,
              "label-tooltip": 
            __props.action === _unref(actionClickType).actionProcessRequest
              ? _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-approved-request-modal-hint-organisational-relationship-1',
                )
              : ''
          
            }, {
              default: _withCtx(() => [
                (__props.action === _unref(actionClickType).actionProcessRequest)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(BaseDropDown, {
                        id: 'orgToOrgTypeId',
                        modelValue: formModel.value.orgToOrgTypeId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.orgToOrgTypeId) = $event)),
                        data: orgRelationshipOptions.value,
                        validation: _unref(vueValidate).orgToOrgTypeId,
                        "class-name": 'gray-dropdown-container tw-h-[58px]',
                        placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-modals-prompt-org-relationship-1',
                )
              
                      }, null, 8, ["modelValue", "data", "validation", "placeholder"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(onGetOrgRelationshipLabel(formModel.value.orgToOrgTypeId)), 1))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "validation", "label", "label-tooltip"]),
            _createVNode(BaseInput, {
              id: "lock-status",
              modelValue: formModel.value.isLocked,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.isLocked) = $event)),
              disabled: true,
              validation: _unref(vueValidate).isLocked,
              label: 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-modals-label-lock-status-1',
            )
          ,
              "label-tooltip": 
            _unref(getComponentUiText)(
              __props.action === _unref(actionClickType).actionProcessRequest
                ? 'app-settings-organisation-manage-access-approved-request-modal-hint-lock-status-1'
                : 'app-settings-organisation-manage-access-approved-offer-modal-hint-lock-status-1',
            )
          
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (formModel.value.isLocked)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(formModel.value.isLocked
                ? _unref(getComponentUiText)(
                    "app-settings-organisation-manage-access-create-org-modal-locked-status-1",
                  )
                : _unref(getComponentUiText)(
                    "app-settings-organisation-manage-access-create-org-modal-unlocked-status-1",
                  )), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "validation", "label", "label-tooltip"]),
            _createVNode(BaseInput, {
              modelValue: formModel.value.role,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formModel.value.role) = $event)),
              validation: _unref(vueValidate).role,
              "validate-on-blur": true,
              disabled: __props.action !== _unref(actionClickType).actionProcessRequest,
              placeholder: 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-approved-request-modal-placehoder-role-1',
            )
          ,
              label: 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-manage-offer-modal-form-label-role-1',
            )
          ,
              "label-tooltip": 
            __props.action === _unref(actionClickType).actionProcessRequest
              ? _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-approved-request-modal-hint-role-1',
                )
              : ''
          
            }, {
              default: _withCtx(() => [
                (__props.action === _unref(actionClickType).actionProcessRequest)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(BaseDropDown, {
                        id: 'permissionId',
                        modelValue: formModel.value.role,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.role) = $event)),
                        data: permissionLevelOptions.value,
                        validation: _unref(vueValidate).role,
                        "class-name": 'gray-dropdown-container tw-min-h-[58px] tw-text-[#FFFFFF]',
                        placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-approved-request-modal-placehoder-role-1',
                )
              
                      }, null, 8, ["modelValue", "data", "validation", "placeholder"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(roleOfOffer.value), 1))
              ]),
              _: 1
            }, 8, ["modelValue", "validation", "disabled", "placeholder", "label", "label-tooltip"]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_b_button, {
                variant: "primary",
                class: "button-verify !tw-bg-[#fff] tw-py-[11px] tw-px-[18px] !tw-text-[#387DFF] tw-text-[15px] tw-font-medium tw-rounded-[27px] !tw-border-[2px]",
                onClick: handleCloseModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-common-action-cancel-button-1")), 1)
                ]),
                _: 1
              }),
              _createVNode(ButtonLoading, {
                class: _normalizeClass(`button-verify !tw-bg-[#F7553C] !tw-border-[#F7553C] tw-text-[15px] tw-font-medium tw-rounded-[27px]`),
                title: 
              _unref(getComponentUiText)(
                __props.action === _unref(actionClickType).actionProcessRequest
                  ? 'app-settings-organisation-manage-access-actions-modal-reject-request-1'
                  : 'app-settings-organisation-manage-access-actions-modal-reject-offer-1',
              )
            ,
                "is-loading": isCallApi.value && !isCallAccept.value,
                onClickAction: _cache[6] || (_cache[6] = ($event: any) => (onSubmit(false)))
              }, null, 8, ["title", "is-loading"]),
              _createVNode(ButtonLoading, {
                class: _normalizeClass(`button-verify  tw-text-[15px] tw-font-medium tw-rounded-[27px]`),
                title: 
              _unref(getComponentUiText)(
                __props.action === _unref(actionClickType).actionProcessRequest
                  ? 'app-settings-organisation-manage-access-actions-modal-accept-request-1'
                  : 'app-settings-organisation-manage-access-actions-modal-accept-offer-1',
              )
            ,
                "is-loading": isCallApi.value && isCallAccept.value,
                onClickAction: _cache[7] || (_cache[7] = ($event: any) => (onSubmit(true)))
              }, null, 8, ["title", "is-loading"])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "value"]))
}
}

})